import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {ToastContainer} from "react-toastify";

const CreateRevenueEvent = () => {

    const navigate = useNavigate();

    const [event, setEvent] = useState(null);
    const [formData, setFormData] = useState({
        id: null,
        name: "",
        start_time: "",
        end_time: "",
        begin_hour_time: "",
        end_hour_time: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.start_time || !formData.end_time || !formData.specialeventurl) {
            alert("Name, Start Date, and End Date, Event URL are required.");
            return;
        }


        formData.eventtype = "Revenue";
        formData.is_public = true;

        try {
            // Simulate API call
            const response = await fetch("/otgservices/createEvent.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                const data = await response.json();
                var event = formData;
                event.id = data.id;
                setEvent(event);

                if (data.status === "success") {
                    toast.success("Revenue Event created successfully!");
                    // Go to the Edit Event Page
                    const eventId = data.id;
                    navigate(`/events/edit-event/${eventId}`, {state: {event}});
                } else {
                    toast.error("Failed to create event: " + (data.message || "Unknown error"));
                }
            }
        } catch (error) {
            alert("Error creating Revenue event. Please try again.");
            console.error(error);
        }
    };

    const handleCancel = () => {
        // Navigate back logic would go here
        navigate(-1);
    };

    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <ToastContainer/>
            <h2 className="text-2xl font-bold mb-4 text-center">Create Revenue Event</h2>
            <div className="max-w-xl mx-auto bg-white p-6 rounded shadow space-y-4">
                <div>
                    <label htmlFor="name" className="block mb-1 text-sm font-medium">
                        Event Name
                    </label>
                    <input
                        id="name"
                        name="name"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded"
                        placeholder="Enter event name"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="start_time" className="block mb-1 text-sm font-medium">
                        Start Date
                    </label>
                    <input
                        id="start_time"
                        name="start_time"
                        type="date"
                        value={formData.start_time}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="end_time" className="block mb-1 text-sm font-medium">
                        End Date
                    </label>
                    <input
                        id="end_time"
                        name="end_time"
                        type="date"
                        value={formData.end_time}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="begin_hour_time" className="block mb-1 text-sm font-medium">
                        Start Time
                    </label>
                    <input
                        id="begin_hour_time"
                        name="begin_hour_time"
                        type="time"
                        value={formData.begin_hour_time}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded"
                        placeholder="e.g., 9:00 AM"
                    />
                </div>

                <div>
                    <label htmlFor="end_hour_time" className="block mb-1 text-sm font-medium">
                        End Time
                    </label>
                    <input
                        id="end_hour_time"
                        name="end_hour_time"
                        type="time"
                        value={formData.end_hour_time}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded"
                        placeholder="e.g., 5:00 PM"
                    />
                </div>


                <div>
                    <label htmlFor="specialeventurl" className="block mb-1 text-sm font-medium">
                        Private Event URL
                    </label>
                    <input
                        id="specialeventurl"
                        name="specialeventurl"
                        type="text"
                        value={formData.specialeventurl}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded"
                    />
                </div>

                <div className="flex justify-between">
                    <button
                        type="button"
                        onClick={handleCancel}
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
                    >
                        Create Revenue Event
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateRevenueEvent;